module.exports = __webpack_public_path__ + "static/media/promo.8063b4c8.png";